/**
 * 2007-2017 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2017 PrestaShop SA
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import $ from 'jquery';
import prestashop from 'prestashop';

prestashop.responsive = prestashop.responsive || {};

prestashop.responsive.current_width = window.innerWidth;
prestashop.responsive.min_width = 992;
prestashop.responsive.mobile = prestashop.responsive.current_width < prestashop.responsive.min_width;

function swapChildren(obj1, obj2) {
  const temp = obj2.children().detach();
  obj2.empty().append(obj1.children().detach());
  obj1.append(temp);
}

function toggleMobileStyles() {
  if (prestashop.responsive.mobile) {
    $("*[id^='_desktop_']").each(function (idx, el) {
      const target = $('#' + el.id.replace('_desktop_', '_mobile_'));
      if (target.length) {
        swapChildren($(el), target);
      }
    });
    $('[data-collapse-hide-mobile]').collapse('hide');

  } else {
    $("*[id^='_mobile_']").each(function (idx, el) {
      const target = $('#' + el.id.replace('_mobile_', '_desktop_'));
      if (target.length) {
        swapChildren($(el), target);
      }

    });
    $('[data-collapse-hide-mobile]').not('.show').collapse('show');
    $('[data-modal-hide-mobile].show').modal('hide');

  }

  prestashop.emit('responsive update', {
    mobile: prestashop.responsive.mobile
  });
}

function generate_menu_mobile() {
  if (prestashop.responsive.mobile) {

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Gestion menu mobile
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // Ouverture et fermeture de la navigation mobile
    $("#nav-mobile__opener").on("click", function (e) {
      e.preventDefault();
      $("body").toggleClass("body__nav-mobile--is-open");
      if ($('.nav-mobile').attr('aria-expanded') == 'false') {
      $('.nav-mobile').attr('aria-expanded',true);
      }
      else {
          $('.nav-mobile').attr('aria-expanded',false);
        }
      $(this).find('i, svg').toggleClass('d-none');
    });
    $("#nav-mobile__closer").on("click", function (e) {
      e.preventDefault();
      $("body").removeClass("body__nav-mobile--is-open");
      $('.nav-mobile').attr('aria-expanded',false);
    });
  }
  prestashop.emit('responsive update', {
    mobile: prestashop.responsive.mobile,
  });
}

$(window).on('resize', function () {
  const cw = prestashop.responsive.current_width;
  const mw = prestashop.responsive.min_width;
  const w = window.innerWidth;
  const toggle = (cw >= mw && w < mw) || (cw < mw && w >= mw);

  prestashop.responsive.current_width = w;
  prestashop.responsive.mobile = prestashop.responsive.current_width < prestashop.responsive.min_width;
  if (toggle) {
    toggleMobileStyles();
    generate_menu_mobile();
  }
});

$(document).ready(function () {
  if (prestashop.responsive.mobile) {
    toggleMobileStyles();
    generate_menu_mobile();
  }

});
